import { Box, MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import { BaseSearchBox } from "../search-box";
import { makeNetworkCall } from "../../utils/fetchData";

export const ReportSearch = ({
  type,
  fiscalYears,
  currentSelectedPeriod,
  onPeriodChange,
  payload,
  setIsLoading,
  setData,
  endpoint,
  setTotals,
  data,
}) => {
  const handleSortOrderChange = (event) => {
    const newSortOrder = event.target.value;
    onPeriodChange(newSortOrder);
    payload.period = newSortOrder;
    makeNetworkCall(endpoint, payload, setData, setTotals, setIsLoading, {});
  };
  const periodFilters = (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        maxWidth: "400px",
        marginLeft: "25px",
      }}
    >
      <FormControl fullWidth>
        <InputLabel id="period-select-label">Period</InputLabel>
        <Select
          labelId="period-select-label"
          id="period-select"
          value={currentSelectedPeriod}
          label="Period"
          onChange={handleSortOrderChange}
          fullWidth
          sx={{ minWidth: 120 }}
        >
          {fiscalYears.length === 0 && (
            <MenuItem value="" disabled>
              No Periods Available
            </MenuItem>
          )}
          {fiscalYears.map((yearPeriod) => (
            <MenuItem key={yearPeriod} value={yearPeriod}>
              {yearPeriod}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
  return BaseSearchBox({
    placeholder: "inventory name...",
    endpoint: endpoint,
    data: data,
    setData: setData,
    setTotals: setTotals,
    setIsLoading: setIsLoading,
    payload: payload,
    otherFilters: periodFilters,
  });
};
